<div class="col-md-6">
  <div id="divInstallation" class="panel-default">
    <div id="typePanel" class="widget-head">
      <h3>Type</h3>
    </div>
    <div class="panel-body">
      <form [formGroup]="fgPerforatedPipe">
        <div formGroupName="fgType">
          <div class="row type" style="margin-bottom: 15px">
            <div class="col-sm-6 type-label">
              <label>Machined Holes</label>
            </div>
            <div class="col-sm-6 type-btn">
              <input formControlName="groovesMachinedWithSaw" hidden />
              <button
              style="margin: 0 6px 0 0;"
                (click)="
                  setFormControlValue(
                    true,
                    fgPerforatedPipe.get('fgType').get('groovesMachinedWithSaw')
                  )
                "
                [ngClass]="{
                  active:
                    fgPerforatedPipe
                      ?.get('fgType')
                      .get('groovesMachinedWithSaw').value === true
                }"
                class="groupBTN perforated-pipe col-md-6 btn btn-alt4 btn-rad"
                type="button"
              >
                Yes
              </button>
              <button
              style="margin: 0 0 0 6px;"
                (click)="
                  setFormControlValue(
                    false,
                    fgPerforatedPipe.get('fgType').get('groovesMachinedWithSaw')
                  )
                "
                [ngClass]="{
                  active:
                    fgPerforatedPipe
                      ?.get('fgType')
                      .get('groovesMachinedWithSaw').value === false
                }"
                class="groupBTN perforated-pipe col-md-6 btn btn-alt4"
                type="button"
              >
                No
              </button>
            </div>
          </div>
          <div class="row type">
            <div class="col-sm-4 type-label">
              <label>Pattern</label>
            </div>
            <div class="col-sm-8">
              <input formControlName="pattern" hidden />
              <div
                [ngClass]="{
                  disabled: this.fgPerforatedPipe.get('fgType').get('pattern')
                    .disabled
                }"
                style="width: 100%; display: flex; justify-content: flex-end;"
              >
                <button
                  (click)="
                    setFormControlValue(
                      patterns.Staggered,
                      fgPerforatedPipe.get('fgType').get('pattern')
                    )
                  "
                  style="width: 94px; margin: 0 6px 0 0;"
                  [ngClass]="{
                    active:
                      fgPerforatedPipe?.get('fgType').get('pattern').value ===
                        patterns.Staggered &&
                      fgPerforatedPipe?.get('fgType').get('pattern').enabled,
                    'disabled-section': this.fgPerforatedPipe
                      .get('fgType')
                      .get('pattern').disabled
                  }"
                  class="groupBTN perforated-pipe col-md-6 btn btn-alt4 btn-rad"
                  type="button"
                >
                  Staggered
                </button>
                <button
                (click)="
                  setFormControlValue(
                    patterns.Helicoidal,
                    fgPerforatedPipe.get('fgType').get('pattern')
                  )
                "
                style="width: 94px; margin: 0 6px 0 6px;"
                [ngClass]="{
                  active:
                    fgPerforatedPipe?.get('fgType').get('pattern').value ===
                      patterns.Helicoidal &&
                    fgPerforatedPipe?.get('fgType').get('pattern').enabled,
                  'disabled-section': this.fgPerforatedPipe
                    .get('fgType')
                    .get('pattern').disabled
                }"
                class="groupBTN perforated-pipe col-md-6 btn btn-alt4"
                type="button"
              >
                Helicoidal
              </button>
              <button
              (click)="
                setFormControlValue(
                  patterns.Aligned,
                  fgPerforatedPipe.get('fgType').get('pattern')
                )
              "
              style="width: 94px; margin: 0 0 0 6px;"
              [ngClass]="{
                active:
                  fgPerforatedPipe?.get('fgType').get('pattern').value ===
                    patterns.Aligned &&
                  fgPerforatedPipe?.get('fgType').get('pattern').enabled,
                'disabled-section': this.fgPerforatedPipe
                  .get('fgType')
                  .get('pattern').disabled
              }"
              class="groupBTN perforated-pipe col-md-6 btn btn-alt4"
              type="button"
            >
              Aligned
            </button>
              </div>
            </div>
          </div>
          <div class="row row-img">
            <div class="col-md-4 type-col">
              <div
                [ngClass]="{
                  selectedOption:
                    fgPerforatedPipe?.get('fgType').get('pattern').value ==
                      patterns.Staggered &&
                    fgPerforatedPipe?.get('fgType').get('pattern').enabled
                }"
              >
                <img
                  src="../../../../../assets/img/perforated/Staggered.png"
                  class="type-image"
                />
              </div>
            </div>
            <div class="col-md-4 type-col">
              <div
                [ngClass]="{
                  selectedOption:
                    fgPerforatedPipe?.get('fgType').get('pattern').value ==
                      patterns.Helicoidal &&
                    fgPerforatedPipe?.get('fgType').get('pattern').enabled
                }"
              >
                <img
                  src="../../../../../assets/img/perforated/Helicoidal.png"
                  class="type-image"
                />
              </div>
            </div>
            <div class="col-md-4 type-col">
              <div
                [ngClass]="{
                  selectedOption:
                    fgPerforatedPipe?.get('fgType').get('pattern').value ==
                      patterns.Aligned &&
                    fgPerforatedPipe?.get('fgType').get('pattern').enabled
                }"
              >
                <img
                  src="../../../../../assets/img/perforated/Aligned.png"
                  class="type-image"
                />
              </div>
            </div>
          </div>
          <div class="row row-img">
            <div class="col-md-4 type-col">
              <p>
                Fig. 1 <br />
                Staggered
              </p>
            </div>
            <div class="col-md-4 type-col">
              <p>
                Fig. 2 <br />
                Helicoidal
              </p>
            </div>
            <div class="col-md-4 type-col">
              <p>
                Fig. 3 <br />
                Aligned
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
